export const secretKey = "ADeuCasb4fDkdakK5IJas3CQ5h0TfrWGbiyHbYHBBIblitnj545GHdnrcdgNS6Q";

export const secretFile = "ADeuASAfdDsadkdakK5IJas3CQ5h0TfrWGbiyHbYHBBIblitndsadJAHSASA7632bnsys7cx3";